import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useAuth } from '../context/AuthContext';
import _ from 'lodash';
import logo from '../assets/logo.svg';
import kakaoIcon from '../assets/kakao.svg';
import googleIcon from '../assets/google.svg';
import semi from '../assets/semi.svg';

import '../styles/LoginPage.scss';

interface IFormData {
  userId: string;
  password: string;
}

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { login, checkSubmissionStatus } = useAuth(); // useAuth 훅 사용
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormData>({
    defaultValues: {
      userId: '',
      password: '',
    },
  });

  const onSubmit: SubmitHandler<IFormData> = async data => {
    try {
      const response = await axios.post('/api/users/login', data);
      await login(response.data.user, response.data.token);
      const hasSubmitted = await checkSubmissionStatus();
      if (hasSubmitted) {
        navigate('/');
      } else {
        navigate('/daily-journal');
      }
    } catch (error) {
      console.error('Login failed', error);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <img src={logo} className="logo" alt="RE:BORN TALK" />
        <p className="subtitle">
          당신의 마음에 다시
          <img src={semi} alt="" /> 생기를 불어넣다
        </p>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <div className="input-wrapper">
              <label htmlFor="userId">아이디</label>
              <input
                type="text"
                id="userId"
                placeholder="아이디를 입력해 주세요"
                {...register('userId', { required: '아이디는 필수 항목입니다.' })}
              />
            </div>
            {_.get(errors, 'userId') && (
              <p className="error-message">{_.get(errors, 'userId.message')}</p>
            )}
          </div>
          <div className="form-group">
            <div className="input-wrapper">
              <label htmlFor="password">비밀번호</label>
              <input
                type="password"
                id="password"
                placeholder="비밀번호를 입력해주세요"
                {...register('password', {
                  required: '비밀번호는 필수 항목입니다.',
                })}
              />
            </div>
            {errors.password && <p className="error-message">{errors.password.message}</p>}
          </div>
          <button type="submit" className="login-button">
            로그인 하기
          </button>
        </form>
        <a href="https://reborn109.com/" target="_blank" className="login-info-button">리본톡이 처음이에요 <span>소개보기</span></a>
        <div className="extra-links">
          <Link to="/register">회원가입</Link>
          {/* <Link to="/register">회원가입</Link> | <Link to="/find-credentials">ID/PW찾기</Link> */}
        </div>        
        <div className="divider">
          <span>SNS 계정 로그인</span>
        </div>
        <div className="login-button-group">
          <button
            type="button"
            className="kakao-login-button"
            onClick={() => {
              window.location.href = '/api/users/kakao';
            }}
          >
            <img src={kakaoIcon} alt="카카오 로그인" />
            <span className="sr-only">카카오로 시작하기</span>
          </button>
          <button
            type="button"
            className="google-login-button"
            onClick={() => {
              window.location.href = '/api/users/google';
            }}
          >
            <img src={googleIcon} alt="구글 로그인" />
            <span className="sr-only">구글로 시작하기</span>
          </button>
        </div>
        {/* <div className="footer-links">
          <Link to="/privacy-policy">개인정보처리방침</Link> |{' '}
          <Link to="/terms-of-service">서비스 이용약관</Link>
        </div> */}
      </div>
    </div>
  );
};

export default LoginPage;
